<div class="list-item__label">
    {{pLabel}}
    <ng-content select="[pListLabel]"></ng-content>
</div>
<div class="list-item__content">
    <ng-content></ng-content>
</div>
